var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.post
    ? _c(
        "div",
        {
          staticClass: "post comments",
          class: _vm.page.network,
          attrs: { id: `loadableContent-comments-${_vm.post.id}` },
        },
        [
          _vm.badWordsFeed
            ? _c("div", { staticClass: "content" }, [
                _c("ul", [
                  _c(
                    "li",
                    { class: `comment-bad-word` },
                    [
                      _c("comment", {
                        attrs: {
                          comment: _vm.post.comment,
                          page: _vm.page,
                          badWordsFeed: _vm.badWordsFeed,
                          badWordList: _vm.badWordList,
                        },
                        on: {
                          hide: _vm.hideComment,
                          delete: _vm.deleteComment,
                          block: _vm.blockUser,
                          getComments: _vm.getComments,
                          likeComment: _vm.likeNodeAction,
                          badWordsDetected: _vm.badWordsDetected,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm.comments
            ? _c("div", { staticClass: "content" }, [
                _vm.page.network == "instagram"
                  ? _c(
                      "div",
                      { staticClass: "activatecomments" },
                      [
                        _c(
                          "vs-dropdown",
                          { attrs: { "vs-trigger-click": true } },
                          [
                            _c(
                              "vs-button",
                              { staticClass: "text-align: right" },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("../../assets/img/icon_tree_dot.svg"),
                                  },
                                }),
                              ]
                            ),
                            _c(
                              "vs-dropdown-menu",
                              [
                                _vm.post.is_comment_enabled == false &&
                                _vm.page.network == "instagram"
                                  ? _c(
                                      "vs-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.switchComment(
                                              _vm.post.id,
                                              _vm.post.is_comment_enabled
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              _vm.$t(
                                                "dash.button.activate.comment"
                                              )
                                            ) +
                                            "\n          "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.post.is_comment_enabled == true &&
                                _vm.page.network == "instagram"
                                  ? _c(
                                      "vs-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.switchComment(
                                              _vm.post.id,
                                              _vm.post.is_comment_enabled
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              _vm.$t(
                                                "dash.button.desactivate.comment"
                                              )
                                            ) +
                                            "\n          "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.page.network == "instagram" &&
                _vm.post.is_comment_enabled == false
                  ? _c("div", { staticClass: "comments-desactivate" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("dash.preview.comment.desactivate")) +
                          "\n    "
                      ),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "stats" }, [
                  _c(
                    "div",
                    {
                      staticClass: "likes-count",
                      class: [{ already: _vm.has_liked }],
                      on: {
                        click: function ($event) {
                          !_vm.has_liked
                            ? _vm.likeNodeAction(_vm.post, true)
                            : ""
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.getCountLikes) +
                          " " +
                          _vm._s(_vm.$t("dash.label.fb.like"))
                      ),
                    ]
                  ),
                  _vm.page.network != "linkedin" &&
                  _vm.page.network != "instagram"
                    ? _c("div", { staticClass: "shares-count" }, [
                        _vm._v(
                          _vm._s(_vm.getCountShares) +
                            " " +
                            _vm._s(_vm.$t("dash.label.fb.shares"))
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "comments-count" }, [
                    _vm._v(
                      _vm._s(_vm.getCountComments) +
                        " " +
                        _vm._s(_vm.$t("dash.label.fb.comments"))
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "message" },
                  [
                    _c("message-comment", {
                      attrs: { node: _vm.post, page: _vm.page },
                      on: {
                        getComments: _vm.getComments,
                        likeComment: _vm.likeNodeAction,
                      },
                    }),
                  ],
                  1
                ),
                _vm.comments.paging && _vm.comments.paging.previous
                  ? _c(
                      "div",
                      { staticClass: "pagination-comments previous-comments" },
                      [
                        _c(
                          "vs-button",
                          {
                            staticClass: "page-btn btn-large",
                            attrs: { "vs-type": "filled" },
                            on: {
                              click: function ($event) {
                                return _vm.paginationComments("previous")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  _vm.$t("dash.moderation.previous-comments")
                                ) +
                                "\n      "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "ul",
                  _vm._l(_vm.comments.data, function (item, key) {
                    return _c(
                      "li",
                      { key: key, class: `comment-${key}` },
                      [
                        _c("comment", {
                          attrs: {
                            comment: item,
                            page: _vm.page,
                            badWordList: _vm.badWordList,
                          },
                          on: {
                            hide: _vm.hideComment,
                            delete: _vm.deleteComment,
                            block: _vm.blockUser,
                            getComments: _vm.getComments,
                            likeComment: _vm.likeNodeAction,
                            badWordsDetected: _vm.badWordsDetected,
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
                _vm.comments.paging && _vm.comments.paging.next
                  ? _c(
                      "div",
                      { staticClass: "pagination-comments next-comments" },
                      [
                        _c(
                          "vs-button",
                          {
                            staticClass: "page-btn btn-large",
                            attrs: { "vs-type": "filled" },
                            on: {
                              click: function ($event) {
                                return _vm.paginationComments("next")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  _vm.$t("dash.moderation.next-comments")
                                ) +
                                "\n      "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _c("div", { staticClass: "content" }, [
                _vm.page.network == "instagram" &&
                _vm.post.is_comment_enabled == false
                  ? _c("div", { staticClass: "comments-desactivate" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("dash.preview.comment.desactivate")) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "stats" }, [
                  _c(
                    "div",
                    {
                      staticClass: "likes-count",
                      class: [{ already: _vm.has_liked }],
                      on: {
                        click: function ($event) {
                          !_vm.has_liked
                            ? _vm.likeNodeAction(_vm.post, true)
                            : ""
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.getCountLikes) +
                          " " +
                          _vm._s(_vm.$t("dash.label.fb.like"))
                      ),
                    ]
                  ),
                  _vm.page.network != "linkedin" &&
                  _vm.page.network != "instagram"
                    ? _c("div", { staticClass: "shares-count" }, [
                        _vm._v(
                          _vm._s(_vm.getCountShares) +
                            " " +
                            _vm._s(_vm.$t("dash.label.fb.shares"))
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "comments-count" }, [
                    _vm._v("0 " + _vm._s(_vm.$t("dash.label.fb.comments"))),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "message" },
                  [
                    _c("message-comment", {
                      attrs: { node: _vm.post, page: _vm.page },
                      on: {
                        getComments: _vm.getComments,
                        likeComment: _vm.likeNodeAction,
                      },
                    }),
                  ],
                  1
                ),
              ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }